<template>
    <!--Componente del prospecto-->
    <form  class="cardForm" v-on:submit.prevent="submitForm"> 
        <div v-show="showdiv">
            <p style="color:red">Los correo no son iguales</p>
        </div>
        <div class="loginIconContainer">
            <div class="loginIcon">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#ffff" class="bi bi-person-fill" viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
                </svg>
            </div>
            </div>
        <br>     
        <center><h2>Registro</h2></center>
        <general @datageneralalumno="getDatageneralalumno">
    
        </general>
        <div v-show="para">
            <p>{{mesaje}}</p>
        </div>
        <button type="sumbit" class="cmp-button" :disabled="btn" :class="{ spanap : showbtnsend }">Guardar Contraseña</button>            
        </form>
    </template>
    <!--Componente del prospecto-->
    <style scoped>
    .cardForm {
    
      border-radius: 6px;
      box-shadow: 0 11px 24px 0 #b0d3eb;
      border: solid 1px #5eabe0;
      background-color: white;
      border-top: solid 8px #0d6eba;
      padding: 24px;
      width: 40%;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 45px;
      
      
      }
      @media only screen and (max-width: 880px) {
          .cardForm {
            width: 80%;
          }
      }
    
    .inputControl {
      position: relative;
       margin-top: 30px;
        display: flex;
    }
    label {
        color: #0d6eba;
        background: white;
        font-size: 14px;
        font-weight: bold;
        position: absolute;
        top: -9px;
        left: 9px;
        padding: 0 8px;
      }
    
      input {
        border-radius: 6px;
        border: solid 1px black;
        background-color: white;
        padding: 10px 16px;
        padding-right: 35px;
        width: 100%;
        font-size: 16px;
        color:  #505050;
      }
    
       button {
        width: 100%;
        margin-top: 20px;
        text-align: center;
      }
    
       h2 {
          margin-top: 5px;
          margin-bottom: 25px;
          color:#0d6eba;
          font-weight:700;
          font-size:24px;
        }
        .cmp-button{
            appearance:none;
            border-radius: 3px;
            cursor:pointer;
            font-size:18px;
            padding:9pt 14px 14px;
            text-align:center;
            font-weight:500;
            background-color:#0d6eba;
            border: 1px solid #0d6eba;
            color:white;
            transition:background-color .4s ease-out,color .3s ease-out,border .4s ease-out;
        }
        .spanap {
        display: none;
        }
    .loginIcon,.loginIconContainer {
        align-items: center;
        display: flex;
        justify-content: center;
    }
    
    .loginIcon {
        background: #000;
        border-radius: 50%;
        height: 38px;
        width: 38px
    }
    
    .loginContainer {
        background-color: #fff;
        border: 0 solid #5eabe0;
        border-radius: 6px;
        border-top: 8px solid #0d6fb8;
        -webkit-box-shadow: 0 11px 24px 0 #b0d3eb;
        box-shadow: 0 11px 24px 0 #b0d3eb;
        margin-bottom: 45px;
        margin-left: auto;
        margin-right: auto;
        padding: 24px;
        text-align: center;
        width: 40%
    }
    </style>
    <script>
    //Componente datosgeneral.vue
    import General from '../alumno/DatosgeneralesAlumnoadd.vue'
    import axios from 'axios';
    export default {
      name: 'AlumnoformComponent',
      props:['correo','tpsch','cicloi'],
      components: {
       General
      },
      data(){
            return {
                mesaje:null,
                para:false,
                btn: false,
                showbtnsend: false,
                nivel: this.tpsch,
                ciclo: this.cicloi,
                    form: {
                    CorreoElectronico: null,
                    Pass: null,
                    Passc: null
                },
                url:process.env.VUE_APP_URL,
                urlgeneral:process.env.VUE_APP_URL_GENERAL,
                urlpost:process.env.VUE_APP_URL_POST,
                showdiv: false,
            };
        },
         methods: {
            
         getDatageneralalumno: function(paramsAlumno) {
          console.log(paramsAlumno);
          this.form.Pass = paramsAlumno.pass;
          this.form.Passc = paramsAlumno.passc;
          this.form.CorreoElectronico = paramsAlumno.correoalumno;
        },
        submitForm(){  
        //this.btn=true;
        //this.showbtnsend = true;
        if(this.form.Pass != this.form.Passc){
            this.showdiv = true;
        }else{
            axios.post(this.urlgeneral+"/api/addprospeccion", this.form)
            .then(response => {
                console.log(response.data.message);
                if(response.data.status == "OK"){
                    this.para = true;
                    this.mesaje = response.data.message;
                    window.location.href = "https://educando-qa.atencionunitec.mx/login";
                }else{
                    this.mesaje = response.data.message;
                    this.para = true;
                }
            }).catch(error => {
                console.log("El Error es: ",error.message);
            });
        }
        },
        }
    }
    </script>